import { Breakpoint } from '@altibox/design-system-component-lib';
import React, { FunctionComponent } from 'react';

import { ImageProps } from 'src/components/image';
import { errorImageProps, infoImageProps } from 'src/resources/images';

import { AlertType } from './alert-type';
import {
  StyledAlert,
  StyledAlertProps,
  StyledDescription,
  StyledIcon,
  StyledTitle,
  StyledWrapper,
} from './alert.styled';

interface OwnProps {
  title: string;
  description?: React.ReactNode;
}

type Props = OwnProps & StyledAlertProps;

const ALERT_IMAGES: Record<AlertType, ImageProps> = {
  [AlertType.ERROR]: errorImageProps,
  [AlertType.INFO]: infoImageProps,
};

export const Alert: FunctionComponent<Props> = (props: Props) => {
  const { title, description, type, ...rest } = props;

  return (
    <StyledAlert type={type} {...rest}>
      <StyledWrapper>
        <StyledIcon {...ALERT_IMAGES[type]} />
        <StyledTitle variant="paragraph2" component="p" maxBreakpoint={Breakpoint.TABLET}>
          {title}
        </StyledTitle>
      </StyledWrapper>
      {description && (
        <StyledDescription variant="paragraph2" component="p" maxBreakpoint={Breakpoint.TABLET}>
          {description}
        </StyledDescription>
      )}
    </StyledAlert>
  );
};
